<template>
  <div class="namad_window mt-4" v-if="status === 'successNamadDetails'">
    <kt-row class="mb-3">
      <img
        class="center_namad"
        :src="getLogoImage()"
        alt="logo-image"
        style="max-width: 150px; max-height: 150px"
      />
    </kt-row>
    <kt-panel class="shaodow_panel_namad">
      <kt-panel-body>
        <div v-if="status === 'successNamadDetails'">
          <kt-row>
            <img
              class="center_namad"
              :src="getShopLogo()"
              alt="shop"
              style="max-width: 100px; max-height: 100px"
            />
          </kt-row>
          <kt-row class="mt-4">
            <h5 class="d-inline-block center_namad text-white-in-dark-mode">
              {{ namadGatewayDetails.shop_name }}
            </h5>
          </kt-row>
          <kt-row class="mt-4 certified">
            <div
              class="d-flex justify-content-center align-items-center m-auto"
            >
              <i class="fa fa-check-circle"></i>
              <span class="mr-2">{{ $t("namad.active_merchant") }}</span>
            </div>
          </kt-row>
          <kt-row class="mt-5">
            <kt-col lg="12" md="12" xs="12">
              <h5 class="form-group text-center ml-4 text-white-in-dark-mode">
                {{ $t("namad.merchant_profile") }}
              </h5>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <form id="userDetails" class="text-justify">
                <div
                  v-if="namadGatewayDetails.merchant_type == merchant_type.REAL"
                  class="info_user mt-1"
                >
                  <div class="key_info_namad text-center w-50">
                    {{ $t("namad.fullname") }}
                  </div>
                  <div class="value text-center w-50">
                    {{ namadGatewayDetails.fullname }}
                  </div>
                </div>
                <div
                  v-else-if="
                    namadGatewayDetails.merchant_type == merchant_type.LEGAL
                  "
                  class="info_user"
                >
                  <div class="key_info_namad text-center w-50">
                    {{ $t("namad.com_name_fa") }}
                  </div>
                  <div class="value text-center w-50">
                    {{ namadGatewayDetails.fullname }}
                  </div>
                </div>
                <div class="info_user mt-3">
                  <div class="key_info_namad text-center w-50">
                    {{ $t("namad.register_date") }}
                  </div>
                  <div class="value text-center w-50">
                    {{ namadGatewayDetails.register_date }}
                  </div>
                </div>
                <div class="info_user mt-3">
                  <div class="key_info_namad text-center w-50">
                    {{ $t("namad.address") }}
                  </div>
                  <div class="value text-center w-50" dir="ltr">
                    {{ namadGatewayDetails.address }}
                  </div>
                </div>
                <div>
                  <a :href="getNamadReportUrl()" target="_blank" class="d-block w-100">
                    <div class="btn w-100 btn-success mt-3">
                      {{ $t("namad.report") }}
                    </div>
                  </a>
                </div>
              </form>
            </kt-col>
          </kt-row>
          <kt-row class="mt-3">
          </kt-row>
        </div>
        <kt-row v-if="status === 'namad_error'" class="center_namad"></kt-row>
      </kt-panel-body>
    </kt-panel>
  </div>
</template>

<script>
import { merchantType } from "@/constants/merchantType";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      merchant_type: merchantType,
    };
  },
  computed: {
    ...mapGetters("gateway", ["namadGatewayDetails", "status", "namad_error"]),
  },
  methods: {
    getLogoImage() {
      return this.namadGatewayDetails.site_logo;
    },
    getShopLogo() {
      if (this.status === "successNamadDetails") {
        return this.namadGatewayDetails.shop_logo;
      }
    },
    getNamadReportUrl() {
      return this.namadGatewayDetails.report_url;
    },
  },

  mounted() {
    this.$store.dispatch("gateway/fetchNamad", this.$route.params.gateway_id);
  },
};
</script>

<style>
.namad_window {
  text-align: center;
  margin: 0 auto;
  max-width: 700px;
  max-height: 50%;
}
.center_namad {
  margin: 0 auto;
}
.certified {
  color: #24cd7b;
}

#report {
  width: 100%;
}
.report {
  width: 100%;
  background-color: seagreen !important;
  max-width: 300px;
  padding: 5px 80px;
}
</style>
